export const ENCAISSEMENT_EN_COURS = 'Encaissement en cours';
export const ENCAISSEMENT_TERMINE = 'Encaissement terminé';
export const TRANSFERT_IMPAYES = 'Traitement des impayés';
